import { render, staticRenderFns } from "./versiones.vue?vue&type=template&id=e0c0b914&scoped=true&"
import script from "./versiones.vue?vue&type=script&lang=js&"
export * from "./versiones.vue?vue&type=script&lang=js&"
import style0 from "./versiones.vue?vue&type=style&index=0&id=e0c0b914&scoped=true&lang=css&"
import style1 from "vue-swatches/dist/vue-swatches.min.css?vue&type=style&index=1&lang=css&"
import style2 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0c0b914",
  null
  
)

export default component.exports